import axios from "axios";

export default axios.create({
  // baseURL: "https://api.staging.dagizo.io/api/v1",
   baseURL: process.env.REACT_APP_API,
});

